
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jv3O2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $kSwu1.useIntl)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $cozmU.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if ((0, $1NBp8.FOLDER_VIEW).match(url)) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("8G1o2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const { data: data, error: error } = (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)({
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    return (0, $cozmU.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("jroIa", function(module, exports) {
/**
 * @generated SignedSource<<8e1cc591f1435412c119051736e0078a>>
 * @relayHash 985f6ee79c133e444ec409d517228f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871
const $fe9e027b65465b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatching"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserHasAncestorWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "985f6ee79c133e444ec409d517228f1d",
            "id": "6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871",
            "metadata": {},
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "operationKind": "query",
            "text": "query WatchDialogComponentWithWatchChildrenQuery($contentId:ID!){singleContent(id:$contentId){__typename,id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
        }
    };
}();
$fe9e027b65465b8b$var$node.hash = "b5ae30f67304ac91f4e47cad0c3cbfda";
var $fe9e027b65465b8b$export$2e2bcd8739ae039 = $fe9e027b65465b8b$var$node;
module.exports["default"] = $fe9e027b65465b8b$export$2e2bcd8739ae039;

});

parcelRegister("g1WP0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("9sPhp")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("9sPhp")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;

});

parcelRegister("9sPhp", function(module, exports) {

let $6e3e81afab5f04aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6e3e81afab5f04aa$var$load("lrXQY"),
    $6e3e81afab5f04aa$var$load("6wr18"),
    $6e3e81afab5f04aa$var$load("ffEVr"),
    $6e3e81afab5f04aa$var$load("7EorR"),
    $6e3e81afab5f04aa$var$load("ea3NB"),
    $6e3e81afab5f04aa$var$load("4g6rd"),
    $6e3e81afab5f04aa$var$load("hhss7"),
    $6e3e81afab5f04aa$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            shouldShowAIImageAcceptanceFlow: false,
            lastAIGenerationParams: null,
            isCurrentAIFCAutoImage: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow)=>this.setState({
                shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow
            });
        this.setLastAIGenerationParams = (lastAIGenerationParams)=>this.setState({
                lastAIGenerationParams: lastAIGenerationParams
            });
        this.setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage)=>this.setState({
                isCurrentAIFCAutoImage: isCurrentAIFCAutoImage
            });
        this.resetToDefaults = ()=>{
            this.setIsModalOpen(false);
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setShouldShowAIImageAcceptanceFlow(false);
            this.setLastAIGenerationParams(null);
            this.setIsCurrentAIFCAutoImage(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $cozmU = parcelRequire("cozmU");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");








var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default),
        __callerPackage__: "content-types-utils"
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default),
        fragmentArtifact: (0, $fgrom.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default),
        fragmentArtifact: (0, $hm7Pp.default),
        __callerPackage__: "content-types-utils"
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        try {
            const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
            const prevCache = readFragmentInterop({
                id: id
            });
            if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
        } catch  {
        // silently fallback to default typename "KnownUser"
        }
        try {
            const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
            writeFragmentInterop({
                fragmentId: id,
                data: {
                    by: {
                        displayName: displayName,
                        __typename: prevTypename
                    },
                    when: newWhen,
                    __typename: 'Version'
                }
            });
        } catch  {
        // silently fail write to cache
        }
    };
    const updateTimestampCacheWithCallback = (0, $cozmU.useCallback)(updateTimestampCache, [
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    return updateTimestampCacheWithCallback;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<4c861bd06806240d51e12f7f085d0825>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<80c5c7a474f99fd1ce0dcfa37ed63a6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<9c87c26246d4536040dd79e5c847aea5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<56e47737c7339d2b755b2c7c5677fdf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("gw4Bt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("3Oija"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("3Oija", function(module, exports) {

let $2c643e358e42e420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c643e358e42e420$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("grWYF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8lt1a = parcelRequire("8lt1a");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $bDgLe.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const hasRun = (0, $cozmU.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("cf6nm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e = ({ isStarred: isStarred, spacing: spacing = 'spacious' })=>{
    const theme = (0, $IQ4Dz.useThemeObserver)();
    const starredColor = theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        label: "",
        color: starredColor,
        spacing: spacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        label: "",
        color: "currentColor",
        spacing: spacing
    });
};
module.exports["StarIcon"] = $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e;

});

parcelRegister("77a1U", function(module, exports) {

var $4GiSr = parcelRequire("4GiSr");


var $9fsLe = parcelRequire("9fsLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $9fsLe.default);
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $4GiSr.default);
const $280d5b858bf30a19$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $cozmU.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const [unstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("4GiSr", function(module, exports) {
/**
 * @generated SignedSource<<3ffaffb5926ed36d9f66867563c732ed>>
 * @relayHash d1da572c7c92b4b266a94268aa3424c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5
const $dc0ccf8bb0c1b893$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1da572c7c92b4b266a94268aa3424c4",
            "id": "e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5",
            "metadata": {},
            "name": "PageStarActionButtonPageUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$dc0ccf8bb0c1b893$var$node.hash = "a57f208826520a57e991955e40d84900";
var $dc0ccf8bb0c1b893$export$2e2bcd8739ae039 = $dc0ccf8bb0c1b893$var$node;
module.exports["default"] = $dc0ccf8bb0c1b893$export$2e2bcd8739ae039;

});

parcelRegister("9fsLe", function(module, exports) {
/**
 * @generated SignedSource<<7f76fd0bae1e7b61d1546ce4fc192079>>
 * @relayHash 893e4cc7292e06a05c8e163bfde7c2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000
const $6cc5c6f8cf8165a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "893e4cc7292e06a05c8e163bfde7c2d8",
            "id": "e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000",
            "metadata": {},
            "name": "PageStarActionButtonPageStarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$6cc5c6f8cf8165a3$var$node.hash = "2fe8e2e773241c74a33b1336ab2db2b2";
var $6cc5c6f8cf8165a3$export$2e2bcd8739ae039 = $6cc5c6f8cf8165a3$var$node;
module.exports["default"] = $6cc5c6f8cf8165a3$export$2e2bcd8739ae039;

});

parcelRegister("cfidN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");

const $774441f3315c6f72$export$5b6a77363c518c1c = (0, $7aRa9.withFlags)(({ flags: flags, title: title, description: description, error: error })=>{
    (0, $cozmU.useEffect)(()=>{
        flags.showErrorFlag({
            id: 'action-button-error',
            title: title,
            description: description
        });
    }, [
        title,
        description,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
});
module.exports["ActionErrorFlag"] = $774441f3315c6f72$export$5b6a77363c518c1c;

});

parcelRegister("7d41Y", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("gqsYd", function(module, exports) {
const $bf558bf49003e931$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["CONFLUENCE_EDITION"] = $bf558bf49003e931$export$4b915fb24c39b396;

});

parcelRegister("49Q03", function(module, exports) {

var $jroIa = parcelRequire("jroIa");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6b4nE = parcelRequire("6b4nE");

parcelRequire("6SsN4");


var $4n1IT = parcelRequire("4n1IT");


var $9DHhW = parcelRequire("9DHhW");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gqqjz = parcelRequire("gqqjz");


var $lOkIA = parcelRequire("lOkIA");


var $jmjWc = parcelRequire("jmjWc");


var $kvJHJ = parcelRequire("kvJHJ");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7zgzO = parcelRequire("7zgzO");


var $g1WP0 = parcelRequire("g1WP0");


var $308Wd = parcelRequire("308Wd");


var $20FI0 = parcelRequire("20FI0");


var $9SsRl = parcelRequire("9SsRl");


var $2REhP = parcelRequire("2REhP");


var $jle6C = parcelRequire("jle6C");


var $6in0A = parcelRequire("6in0A");


const $47908050ea4fd9b1$export$9c5737ae30e94007 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aohZt",
    name: "LazyWatchDialogContent",
    loader: async ()=>(await (parcelRequire("9H84N"))).WatchDialogContent,
    loading: ({ shouldSSRWatchButton: shouldSSRWatchButton })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: '325px',
                height: '180px'
            }
        }, !shouldSSRWatchButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        }))
});

const $47908050ea4fd9b1$var$LazyWatchDialogShortcut = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gDGxN",
    name: "LazyWatchDialogShortcut",
    loader: async ()=>(await (parcelRequire("6Uey7"))).WatchDialogShortcut
});
const $47908050ea4fd9b1$var$i18n = (0, $kSwu1.defineMessages)({
    watchContentDialogLabel: {
        id: "watch-dialog.popup.label",
        defaultMessage: "Watch content dialog"
    }
});
const $47908050ea4fd9b1$export$f521883565cfd8d9 = (0, $jroIa.default);
const $47908050ea4fd9b1$export$4b54507e0234ad87 = (0, $kSwu1.injectIntl)(({ contentId: contentId, spaceId: spaceId, params: params, defaultTab: defaultTab, customPlacement: customPlacement, flagsContainer: flagsContainer, isDisabled: /**
   * This disables the usage of the watch button and dialog.
   *
   * Note: If a `customTrigger` is provided, this will be passed through
   * as `isDisabled`. However, as a fallback, even if the button is not
   * disabled properly, the logic here will continue to be disabled.
   */ isDisabled, customTrigger: customTrigger, useShortcut: useShortcut, shouldSSRWatchButton: shouldSSRWatchButton, skipTrialDetailsQuery: skipTrialDetailsQuery, contentType: contentType, componentLocation: componentLocation, intl: intl })=>{
    const [dialogOpen, setDialogOpen] = (0, $cozmU.useState)(false);
    const [shouldOpenWatchDialogFromQueryParams, setShouldOpenWatchDialogFromQueryParams] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const nudgeRef = (0, $cozmU.useRef)(null);
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    (0, $cozmU.useEffect)(()=>{
        if (isDisabled) return;
        const { openWatchModal: openWatchModal } = getQueryParams();
        setShouldOpenWatchDialogFromQueryParams(openWatchModal === 'true' && (componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).SPACE_OVERVIEW || componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE));
        if (shouldOpenWatchDialogFromQueryParams) setDialogOpen(true);
    }, [
        isDisabled,
        getQueryParams,
        componentLocation,
        shouldOpenWatchDialogFromQueryParams
    ]);
    const removeOpenModalQueryParams = ()=>{
        const queryParams = getQueryParams();
        if (queryParams.openWatchModal) {
            setQueryParams({
                ...queryParams,
                openWatchModal: undefined
            }, true);
            setShouldOpenWatchDialogFromQueryParams(false);
        }
    };
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        // Do not enable open the dialog if watch is disabled
        if (isDisabled) return;
        setDialogOpen((prevState)=>!prevState);
    }, [
        isDisabled
    ]);
    const isWatching = (0, $cozmU.useCallback)(()=>{
        // If watch is disabled, then the user will default to not watching
        return isDisabled ? false : isWatchingContent || isWatchingSpace || isWatchingChildren || hasAncestorWatchingChildren;
    }, [
        isWatchingContent,
        isWatchingChildren,
        hasAncestorWatchingChildren,
        isWatchingSpace,
        isDisabled
    ]);
    const updateQueryHandler = (updateContentType, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            variables: {
                contentId: contentId
            },
            __callerPackage__: "watch-dialog"
        });
        switch(updateContentType){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        (0, $fEmGS.writeQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            data: contentData,
            __callerPackage__: "watch-dialog"
        });
    };
    const fireWatchAnalyticsEvent = (0, $cozmU.useCallback)((action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchButton'
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const [watchContent] = (0, $308Wd.useMutationInterop)((0, $6in0A.default), {
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            toggleDialog();
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE),
                error: error.message
            });
        },
        update: (_, { data: { watchContent: watchContentData } })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, watchContentData.content.currentUserIsWatching);
        },
        __callerPackage__: "watch-dialog"
    });
    const handleOneClickWatch = (0, $cozmU.useCallback)(async ()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE));
        if (experienceState === null || experienceState.hasStopped) experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
        });
        await watchContent({
            variables: {
                id: contentId
            }
        });
    }, [
        watchContent,
        contentId,
        experienceTracker
    ]);
    const handleWatchButtonClick = (0, $cozmU.useCallback)(async ()=>{
        if (dialogOpen || isWatching()) toggleDialog();
        else await handleOneClickWatch();
    }, [
        toggleDialog,
        isWatching,
        dialogOpen,
        handleOneClickWatch
    ]);
    const openDialog = ()=>{
        setDialogOpen(true);
    };
    const closeDialog = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'dialog',
                actionSubjectId: 'watchDialog',
                source: 'WatchDialogContent',
                attributes: {
                    contentType: contentType
                }
            }
        }).fire();
        setDialogOpen(false);
    };
    const renderPopupTrigger = (triggerProps)=>{
        const TriggerButton = customTrigger || (0, $20FI0.WatchButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerButton, {
            isDisabled: isDisabled,
            isWatching: isWatching(),
            isSelected: dialogOpen,
            onMouseOver: $47908050ea4fd9b1$export$9c5737ae30e94007.preload,
            onClick: handleWatchButtonClick,
            triggerProps: triggerProps,
            shouldSSRWatchButton: shouldSSRWatchButton,
            defaultTab: defaultTab,
            contentId: contentId,
            updateQueryHandler: updateQueryHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE),
            attributes: {
                isWatching: isWatching()
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
        }));
    };
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"}`
            },
            ref: nudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$export$9c5737ae30e94007, {
            contentId: contentId,
            spaceId: spaceId,
            defaultTab: defaultTab,
            params: params,
            closeWatchDialog: closeDialog,
            updateQueryHandler: updateQueryHandler,
            skipTrialDetailsQuery: skipTrialDetailsQuery,
            contentType: contentType,
            shouldOpenWatchDialogFromQueryParams: shouldOpenWatchDialogFromQueryParams,
            removeOpenModalQueryParams: removeOpenModalQueryParams
        })), dialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1WP0.AsyncWrapper), {
            trigger: "watch-page",
            showImage: false,
            width: 357,
            reference: nudgeRef
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, useShortcut && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$var$LazyWatchDialogShortcut, {
        contentId: contentId,
        contentType: contentType,
        params: params,
        flagsContainer: flagsContainer,
        openDialog: openDialog,
        updateQueryHandler: updateQueryHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        content: ()=>renderPopupContent(),
        trigger: renderPopupTrigger,
        placement: customPlacement,
        role: "dialog",
        label: intl.formatMessage($47908050ea4fd9b1$var$i18n.watchContentDialogLabel),
        testId: "watch-content-dialog",
        shouldRenderToParent: true
    }));
});
$47908050ea4fd9b1$export$4b54507e0234ad87.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }).isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number.isRequired,
    customPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    customTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType,
    useShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    skipTrialDetailsQuery: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["WatchDialogComponentWithWatchChildrenQuery"] = $47908050ea4fd9b1$export$f521883565cfd8d9;
module.exports["WatchDialogComponent"] = $47908050ea4fd9b1$export$4b54507e0234ad87;

});

parcelRegister("20FI0", function(module, exports) {
/* WatchButton.js generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7ZB0A = parcelRequire("7ZB0A");


var $XgBmC = parcelRequire("XgBmC");


var $a79Sy = parcelRequire("a79Sy");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $cMvQV = parcelRequire("cMvQV");

const $176bef54c656e043$var$i18n = (0, $kSwu1.defineMessages)({
    startWatchingIconLabel: {
        id: "watch-dialog.watch-button.start.watching.label",
        defaultMessage: "Start watching"
    },
    stopWatchingIconLabel: {
        id: "watch-dialog.watch-button.stop.watching.label",
        defaultMessage: "Stop watching"
    },
    watchStopTooltip: {
        id: "watch-dialog.stop.button.tooltip",
        defaultMessage: "Stop watching"
    },
    watchStartTooltip: {
        id: "watch-dialog.start.button.tooltip",
        defaultMessage: "Watch"
    }
});
const $176bef54c656e043$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0sElkwuNcX",
            __cmplp.className
        ])
    });
});
const $176bef54c656e043$var$WatchButtonComponent = ({ isDisabled: isDisabled, isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, intl: intl, triggerProps: triggerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireClickAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        const analyticsData = {
            action: 'clicked',
            actionSubject: 'content-watch-button',
            source: 'viewPageScreen'
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleWatchButtonClick = ()=>{
        onClick();
        fireClickAnalyticsEvent();
    };
    const shortcutContent = isWatching ? intl.formatMessage($176bef54c656e043$var$i18n.watchStopTooltip) : intl.formatMessage($176bef54c656e043$var$i18n.watchStartTooltip);
    const getTooltipContent = ()=>{
        if (isDisabled) return undefined;
        if (isLiveEditMode || isOnEditRoute) return shortcutContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: shortcutContent,
            isTooltip: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: getTooltipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($176bef54c656e043$export$2d5d2ba3c7c8c40b, {
        "data-id": "page-watch-button",
        "data-test-id": "page-watch-button",
        testId: "page-watch-button",
        appearance: "subtle",
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleWatchButtonClick,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        iconBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($XgBmC))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.stopWatchingIconLabel),
            testId: "watch-filled-icon",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.startWatchingIconLabel),
            testId: "watch-icon",
            spacing: "spacious"
        }),
        ...triggerProps
    }));
};
$176bef54c656e043$var$WatchButtonComponent.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isWatching: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    triggerProps: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $176bef54c656e043$export$e149a93a7ac7f896 = (0, $kSwu1.injectIntl)($176bef54c656e043$var$WatchButtonComponent);
module.exports["WatchButton"] = $176bef54c656e043$export$e149a93a7ac7f896;

});

parcelRegister("2REhP", function(module, exports) {
const $215fc810f2773ade$export$613942ed7ac4b968 = {
    PAGE: 0,
    SPACE_OVERVIEW: 1,
    FEED: 2,
    WHITEBOARD: 3
};
module.exports["WATCH_DIALOG_LOCATION"] = $215fc810f2773ade$export$613942ed7ac4b968;

});

parcelRegister("jle6C", function(module, exports) {
var $b11a466056fa4426$export$f8bb0b205e1c369c = /*#__PURE__*/ function(UpdateContentType) {
    UpdateContentType["CONTENT"] = "content";
    UpdateContentType["CHILDREN"] = "children";
    UpdateContentType["BLOGS_IN_SPACE"] = "blogs";
    UpdateContentType["SPACE"] = "space";
    return UpdateContentType;
}({});
var $b11a466056fa4426$export$3b880fb327a46f45 = /*#__PURE__*/ function(UpdateType) {
    UpdateType["WATCH"] = "watch";
    UpdateType["UNWATCH"] = "unwatch";
    return UpdateType;
}({});
module.exports["UpdateContentType"] = $b11a466056fa4426$export$f8bb0b205e1c369c;
module.exports["UpdateType"] = $b11a466056fa4426$export$3b880fb327a46f45;

});

parcelRegister("6in0A", function(module, exports) {
/**
 * @generated SignedSource<<fba01a40abf41f38229c896823374e27>>
 * @relayHash fd81f231087cf7200e9dc6564487d4ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286
const $e1f35a163a9ce341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fd81f231087cf7200e9dc6564487d4ac",
            "id": "8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286",
            "metadata": {},
            "name": "WatchDialogContentWatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchDialogContentWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$e1f35a163a9ce341$var$node.hash = "c3af78be0429c7abdaa087ce8a337162";
var $e1f35a163a9ce341$export$2e2bcd8739ae039 = $e1f35a163a9ce341$var$node;
module.exports["default"] = $e1f35a163a9ce341$export$2e2bcd8739ae039;

});

parcelRegister("9H84N", function(module, exports) {

let $70ee6506bad36a48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $70ee6506bad36a48$var$load("8d6BA"),
    $70ee6506bad36a48$var$load("6damH"),
    $70ee6506bad36a48$var$load("kHXvF"),
    $70ee6506bad36a48$var$load("9OSao")
]).then(()=>parcelRequire('jjM3c'));

});

parcelRegister("6Uey7", function(module, exports) {

let $507342388c13d0d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $507342388c13d0d6$var$load("8hbZ5").then(()=>parcelRequire('j00wp'));

});

parcelRegister("f9HtC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0896bd7bf351fc8$export$73075fe16d77da88 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ckcO3",
    name: "ManageWatcherDialogLoader",
    loader: async ()=>(await (parcelRequire("cbJg4"))).ManageWatcherDialog
});
module.exports["ManageWatcherDialogLoader"] = $b0896bd7bf351fc8$export$73075fe16d77da88;

});

parcelRegister("cbJg4", function(module, exports) {

let $8df99e73284d8611$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8df99e73284d8611$var$load("6wr18"),
    $8df99e73284d8611$var$load("c831e"),
    $8df99e73284d8611$var$load("1GCFv"),
    $8df99e73284d8611$var$load("6dLts"),
    $8df99e73284d8611$var$load("jdPbE"),
    $8df99e73284d8611$var$load("ffEVr"),
    $8df99e73284d8611$var$load("h4Nf7"),
    $8df99e73284d8611$var$load("Wowvf"),
    $8df99e73284d8611$var$load("4g6rd"),
    $8df99e73284d8611$var$load("7EorR"),
    $8df99e73284d8611$var$load("hhss7"),
    $8df99e73284d8611$var$load("iJwzY")
]).then(()=>parcelRequire('45gVm'));

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("itczW"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $krxYo = parcelRequire("krxYo");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $kSwu1.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("itczW", function(module, exports) {

let $d724b14ae0530501$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d724b14ae0530501$var$load("8d6BA"),
    $d724b14ae0530501$var$load("48yNj"),
    $d724b14ae0530501$var$load("hXYTt"),
    $d724b14ae0530501$var$load("6wr18"),
    $d724b14ae0530501$var$load("6HLQW"),
    $d724b14ae0530501$var$load("6ufIQ"),
    $d724b14ae0530501$var$load("j8Ant"),
    $d724b14ae0530501$var$load("aP4DK"),
    $d724b14ae0530501$var$load("2F69B"),
    $d724b14ae0530501$var$load("4fYzp"),
    $d724b14ae0530501$var$load("ezYRV"),
    $d724b14ae0530501$var$load("el56J"),
    $d724b14ae0530501$var$load("5zDuS"),
    $d724b14ae0530501$var$load("ffEVr"),
    $d724b14ae0530501$var$load("7EorR"),
    $d724b14ae0530501$var$load("ea3NB"),
    $d724b14ae0530501$var$load("9cpj1"),
    $d724b14ae0530501$var$load("excC5"),
    $d724b14ae0530501$var$load("aLbuU"),
    $d724b14ae0530501$var$load("a2GlH"),
    $d724b14ae0530501$var$load("ayJxT"),
    $d724b14ae0530501$var$load("hhss7"),
    $d724b14ae0530501$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("l7iY7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $cozmU.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible);
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("dt7Ba"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("dt7Ba", function(module, exports) {

let $9ce3e0b09bd57507$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9ce3e0b09bd57507$var$load("ezYRV"),
    $9ce3e0b09bd57507$var$load("8d6BA"),
    $9ce3e0b09bd57507$var$load("llcQo"),
    $9ce3e0b09bd57507$var$load("fb12y"),
    $9ce3e0b09bd57507$var$load("dAnEF"),
    $9ce3e0b09bd57507$var$load("48yNj"),
    $9ce3e0b09bd57507$var$load("hXYTt"),
    $9ce3e0b09bd57507$var$load("4g6rd"),
    $9ce3e0b09bd57507$var$load("9gCvF"),
    $9ce3e0b09bd57507$var$load("6wr18"),
    $9ce3e0b09bd57507$var$load("e4XZ1"),
    $9ce3e0b09bd57507$var$load("4tFwP"),
    $9ce3e0b09bd57507$var$load("cvw7S"),
    $9ce3e0b09bd57507$var$load("gUrlb"),
    $9ce3e0b09bd57507$var$load("gbDLp"),
    $9ce3e0b09bd57507$var$load("1v24l"),
    $9ce3e0b09bd57507$var$load("4Pu1k"),
    $9ce3e0b09bd57507$var$load("hBTro"),
    $9ce3e0b09bd57507$var$load("9pso5"),
    $9ce3e0b09bd57507$var$load("4fYzp"),
    $9ce3e0b09bd57507$var$load("1GCFv"),
    $9ce3e0b09bd57507$var$load("5zDuS"),
    $9ce3e0b09bd57507$var$load("jzPyj"),
    $9ce3e0b09bd57507$var$load("251nM"),
    $9ce3e0b09bd57507$var$load("bxj2D"),
    $9ce3e0b09bd57507$var$load("Tjs4D"),
    $9ce3e0b09bd57507$var$load("i1I18"),
    $9ce3e0b09bd57507$var$load("kHXvF"),
    $9ce3e0b09bd57507$var$load("ea3NB"),
    $9ce3e0b09bd57507$var$load("ffEVr"),
    $9ce3e0b09bd57507$var$load("fwbNS"),
    $9ce3e0b09bd57507$var$load("8OeKT"),
    $9ce3e0b09bd57507$var$load("Wowvf"),
    $9ce3e0b09bd57507$var$load("5sZTx"),
    $9ce3e0b09bd57507$var$load("deTdD"),
    $9ce3e0b09bd57507$var$load("ayJxT"),
    $9ce3e0b09bd57507$var$load("hhss7"),
    $9ce3e0b09bd57507$var$load("7EorR"),
    $9ce3e0b09bd57507$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");


var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("lYrp8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ftFOj = parcelRequire("ftFOj");

const $c3ac8a024e96d385$export$bffe0f7f3be64e87 = (spaceKey, milestone, options = {})=>{
    const { skip: skip = false } = options;
    const { isSmartFoldersEnabled: isSmartFoldersEnabled, loading: loading } = (0, $ftFOj.useIsSmartFoldersEnabled)(skip ? null : spaceKey);
    if (skip) return {
        isSmartFoldersEnabledForMilestone: false,
        loading: false
    };
    // eslint-disable-next-line confluence-feature-gating/inline-usage
    return {
        isSmartFoldersEnabledForMilestone: isSmartFoldersEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) >= milestone,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabledForMilestone"] = $c3ac8a024e96d385$export$bffe0f7f3be64e87;

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("713Hm"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("713Hm", function(module, exports) {

let $51bb7ed47aec9e18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51bb7ed47aec9e18$var$load("cPaXL").then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("irgaA"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("irgaA", function(module, exports) {

let $d6c74a91aa24a2e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6c74a91aa24a2e0$var$load("fb12y"),
    $d6c74a91aa24a2e0$var$load("dAnEF"),
    $d6c74a91aa24a2e0$var$load("9gCvF"),
    $d6c74a91aa24a2e0$var$load("6wr18"),
    $d6c74a91aa24a2e0$var$load("dRQ13"),
    $d6c74a91aa24a2e0$var$load("4QN8n"),
    $d6c74a91aa24a2e0$var$load("LWh5V"),
    $d6c74a91aa24a2e0$var$load("ffEVr"),
    $d6c74a91aa24a2e0$var$load("Wowvf"),
    $d6c74a91aa24a2e0$var$load("kHXvF"),
    $d6c74a91aa24a2e0$var$load("iWnyc"),
    $d6c74a91aa24a2e0$var$load("excC5"),
    $d6c74a91aa24a2e0$var$load("hhss7"),
    $d6c74a91aa24a2e0$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("1AbrA", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a94896b24fa6d771$export$833a1d1f1b7e4f0f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MiFff",
    name: "PageQuickActionAutomationMenu",
    loader: async ()=>(await (parcelRequire("hrGvV"))).PageQuickActionAutomationMenu
});
module.exports["PageQuickActionAutomationMenu"] = $a94896b24fa6d771$export$833a1d1f1b7e4f0f;

});

parcelRegister("hrGvV", function(module, exports) {

let $cb35efa81ad7c5b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb35efa81ad7c5b0$var$load("48yNj"),
    $cb35efa81ad7c5b0$var$load("hXYTt"),
    $cb35efa81ad7c5b0$var$load("4poK5"),
    $cb35efa81ad7c5b0$var$load("4g6rd"),
    $cb35efa81ad7c5b0$var$load("1X4na"),
    $cb35efa81ad7c5b0$var$load("4xZ5N"),
    $cb35efa81ad7c5b0$var$load("4AElS"),
    $cb35efa81ad7c5b0$var$load("kHXvF"),
    $cb35efa81ad7c5b0$var$load("iWnyc"),
    $cb35efa81ad7c5b0$var$load("Wowvf"),
    $cb35efa81ad7c5b0$var$load("7EorR"),
    $cb35efa81ad7c5b0$var$load("hhss7"),
    $cb35efa81ad7c5b0$var$load("9QyoN")
]).then(()=>parcelRequire('bm1ob'));

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("7mlfc"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("7mlfc", function(module, exports) {

let $55bb111cacf79405$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $55bb111cacf79405$var$load("8d6BA"),
    $55bb111cacf79405$var$load("iWnyc"),
    $55bb111cacf79405$var$load("9gCvF"),
    $55bb111cacf79405$var$load("6wr18"),
    $55bb111cacf79405$var$load("33ouG"),
    $55bb111cacf79405$var$load("73HOd"),
    $55bb111cacf79405$var$load("LWh5V"),
    $55bb111cacf79405$var$load("Wowvf"),
    $55bb111cacf79405$var$load("kHXvF"),
    $55bb111cacf79405$var$load("excC5"),
    $55bb111cacf79405$var$load("ffEVr"),
    $55bb111cacf79405$var$load("hhss7"),
    $55bb111cacf79405$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("kQAny"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("kQAny", function(module, exports) {

let $f2d4e20fe9ee459d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2d4e20fe9ee459d$var$load("48yNj"),
    $f2d4e20fe9ee459d$var$load("hXYTt"),
    $f2d4e20fe9ee459d$var$load("4g6rd"),
    $f2d4e20fe9ee459d$var$load("9gCvF"),
    $f2d4e20fe9ee459d$var$load("6wr18"),
    $f2d4e20fe9ee459d$var$load("4tFwP"),
    $f2d4e20fe9ee459d$var$load("cvw7S"),
    $f2d4e20fe9ee459d$var$load("hBTro"),
    $f2d4e20fe9ee459d$var$load("9pso5"),
    $f2d4e20fe9ee459d$var$load("251nM"),
    $f2d4e20fe9ee459d$var$load("bxj2D"),
    $f2d4e20fe9ee459d$var$load("ffEVr"),
    $f2d4e20fe9ee459d$var$load("Tjs4D"),
    $f2d4e20fe9ee459d$var$load("kHXvF"),
    $f2d4e20fe9ee459d$var$load("iWnyc"),
    $f2d4e20fe9ee459d$var$load("excC5"),
    $f2d4e20fe9ee459d$var$load("7EorR"),
    $f2d4e20fe9ee459d$var$load("Wowvf"),
    $f2d4e20fe9ee459d$var$load("hhss7"),
    $f2d4e20fe9ee459d$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("5wA2k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5qRqQ = parcelRequire("5qRqQ");


var $7TqMU = parcelRequire("7TqMU");

const $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $db92b1048ab2b69e$var$DEFAULT_PROVIDER = (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)['google-drive'];
const $db92b1048ab2b69e$var$normalizeProviderName = (name)=>name.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const $db92b1048ab2b69e$var$providerByContainerApp = {
    [$db92b1048ab2b69e$var$normalizeProviderName('Google Drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive-connector')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive-rsl')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('lite-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('SharePoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint-connector')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('ai-3p-connector:sharepoint-domain')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('OneDrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive-connector')]: 'onedrive'
};
const $db92b1048ab2b69e$var$rememberedSources = new Map();
const $db92b1048ab2b69e$var$subscribers = new Set();
const $db92b1048ab2b69e$var$subscribe = (callback)=>{
    $db92b1048ab2b69e$var$subscribers.add(callback);
    return ()=>{
        $db92b1048ab2b69e$var$subscribers.delete(callback);
    };
};
const $db92b1048ab2b69e$var$skipSubscribe = ()=>()=>{};
const $db92b1048ab2b69e$var$getSkippedRememberedSource = ()=>undefined;
const $db92b1048ab2b69e$var$notifySubscribers = ()=>{
    $db92b1048ab2b69e$var$subscribers.forEach((callback)=>callback());
};
const $db92b1048ab2b69e$var$getSourceFromProvider = (provider)=>{
    const providerConfig = provider ? (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)[provider] : undefined;
    return provider && providerConfig ? {
        appName: providerConfig.displayName,
        provider: provider
    } : undefined;
};
const $db92b1048ab2b69e$var$getProviderFromContainerAri = (containerAri)=>{
    if (!containerAri) return undefined;
    const normalizedContainerAri = containerAri.toLowerCase();
    if (normalizedContainerAri.includes('microsoft.sharepoint') || normalizedContainerAri.includes(':sharepoint::')) return 'sharepoint';
    if (normalizedContainerAri.includes('microsoft.onedrive') || normalizedContainerAri.includes(':onedrive::')) return 'onedrive';
    if (normalizedContainerAri.includes('google.google-drive') || normalizedContainerAri.includes(':drive::')) return 'google-drive';
    return undefined;
};
const $db92b1048ab2b69e$var$getSourceFromContainerApp = (containerApp)=>$db92b1048ab2b69e$var$getSourceFromProvider(containerApp ? $db92b1048ab2b69e$var$providerByContainerApp[$db92b1048ab2b69e$var$normalizeProviderName(containerApp)] : undefined);
const $db92b1048ab2b69e$var$parseSmartFolderContentProperties = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (typeof parsedValue !== 'object' || parsedValue === null) return undefined;
            const contentProperties = parsedValue;
            if (typeof contentProperties.value === 'string' || typeof contentProperties.value === 'object') {
                parsedValue = contentProperties.value;
                continue;
            }
            return contentProperties;
        }
    } catch  {
        return undefined;
    }
    return typeof parsedValue === 'object' && parsedValue !== null ? parsedValue : undefined;
};
const $db92b1048ab2b69e$var$getOptionalTrimmedString = (value)=>{
    if (typeof value !== 'string') return undefined;
    const trimmedValue = value.trim();
    return trimmedValue.length > 0 ? trimmedValue : undefined;
};
const $db92b1048ab2b69e$var$getSafeHttpUrl = (value)=>{
    if (!value) return undefined;
    try {
        const parsedUrl = new URL(value);
        return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:' ? parsedUrl.href : undefined;
    } catch  {
        return undefined;
    }
};
const $db92b1048ab2b69e$var$getSourceFromParsedValue = (parsedValue)=>{
    const containerApp = typeof parsedValue.containerApp === 'string' ? parsedValue.containerApp : typeof parsedValue.appName === 'string' ? parsedValue.appName : undefined;
    const sourceFromContainerApp = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (sourceFromContainerApp) return sourceFromContainerApp;
    const providerName = typeof parsedValue.provider === 'string' ? parsedValue.provider : undefined;
    const sourceFromProvider = $db92b1048ab2b69e$var$getSourceFromContainerApp(providerName);
    if (sourceFromProvider) return sourceFromProvider;
    const containerAri = typeof parsedValue.containerAri === 'string' ? parsedValue.containerAri : undefined;
    return $db92b1048ab2b69e$var$getSourceFromProvider($db92b1048ab2b69e$var$getProviderFromContainerAri(containerAri));
};
const $db92b1048ab2b69e$var$getParsedSmartFolderContentProperties = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    return smartFolderProperties?.value ? $db92b1048ab2b69e$var$parseSmartFolderContentProperties(smartFolderProperties.value) : undefined;
};
const $db92b1048ab2b69e$var$getSourceFromProperties = (properties)=>{
    const parsedValue = $db92b1048ab2b69e$var$getParsedSmartFolderContentProperties(properties);
    return parsedValue ? $db92b1048ab2b69e$var$getSourceFromParsedValue(parsedValue) : undefined;
};
const $db92b1048ab2b69e$var$getDefaultQuickActionSource = ()=>({
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    });
const $db92b1048ab2b69e$var$buildSmartFolderSourceContext = (source, parsedValue)=>{
    const sourcePath = $db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.sourcePath);
    const sourceName = $db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.sourceName) ?? sourcePath ?? source.appName;
    return {
        ...source,
        sourceName: sourceName,
        sourcePath: sourcePath,
        sourceUrl: $db92b1048ab2b69e$var$getSafeHttpUrl($db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.sourceUrl)),
        lastSynced: $db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.lastSynced),
        lastSyncAttemptedAt: $db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.lastSyncAttemptedAt),
        syncErrorType: $db92b1048ab2b69e$var$getOptionalTrimmedString(parsedValue?.syncErrorType)
    };
};
const $db92b1048ab2b69e$export$1fe4bd7337433729 = (properties)=>$db92b1048ab2b69e$var$getParsedSmartFolderContentProperties(properties)?.paused === true;
const $db92b1048ab2b69e$export$e4fd7f25a798c5a7 = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    const lastSynced = $db92b1048ab2b69e$var$parseSmartFolderContentProperties(smartFolderProperties?.value)?.lastSynced;
    return typeof lastSynced === 'string' ? lastSynced : null;
};
const $db92b1048ab2b69e$export$a4e5a78e2b12bcff = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    const syncErrorType = $db92b1048ab2b69e$var$parseSmartFolderContentProperties(smartFolderProperties?.value)?.syncErrorType;
    return typeof syncErrorType === 'string' ? (0, $7TqMU.getSyncErrorState)(syncErrorType) : null;
};
const $db92b1048ab2b69e$export$91c2322e7dd18830 = ({ containerApp: containerApp, folderId: folderId })=>{
    const source = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (!source) return;
    $db92b1048ab2b69e$var$rememberedSources.set(folderId, source);
    $db92b1048ab2b69e$var$notifySubscribers();
};
const $db92b1048ab2b69e$export$e09566dabae6f841 = (properties)=>$db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? $db92b1048ab2b69e$var$getDefaultQuickActionSource();
const $db92b1048ab2b69e$export$d0648489dd5697b1 = (properties)=>$db92b1048ab2b69e$var$buildSmartFolderSourceContext($db92b1048ab2b69e$export$e09566dabae6f841(properties), $db92b1048ab2b69e$var$getParsedSmartFolderContentProperties(properties));
const $db92b1048ab2b69e$export$89fe473835f648f3 = (folderId, properties, options = {})=>{
    const { skip: skip = false } = options;
    const rememberedSource = (0, $cozmU.useSyncExternalStore)(skip ? $db92b1048ab2b69e$var$skipSubscribe : $db92b1048ab2b69e$var$subscribe, skip ? $db92b1048ab2b69e$var$getSkippedRememberedSource : ()=>$db92b1048ab2b69e$var$rememberedSources.get(folderId), $db92b1048ab2b69e$var$getSkippedRememberedSource);
    if (skip) return $db92b1048ab2b69e$var$getDefaultQuickActionSource();
    return $db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? rememberedSource ?? $db92b1048ab2b69e$var$getDefaultQuickActionSource();
};
const $db92b1048ab2b69e$export$81d17f5bc9dc504 = (folderId, properties, options = {})=>{
    const source = $db92b1048ab2b69e$export$89fe473835f648f3(folderId, properties, options);
    return $db92b1048ab2b69e$var$buildSmartFolderSourceContext(source, $db92b1048ab2b69e$var$getParsedSmartFolderContentProperties(properties));
};
module.exports["getIsSmartFolderSyncPaused"] = $db92b1048ab2b69e$export$1fe4bd7337433729;
module.exports["getSmartFolderLastSynced"] = $db92b1048ab2b69e$export$e4fd7f25a798c5a7;
module.exports["getSmartFolderSyncErrorState"] = $db92b1048ab2b69e$export$a4e5a78e2b12bcff;
module.exports["rememberSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$91c2322e7dd18830;
module.exports["getSmartFolderSourceContext"] = $db92b1048ab2b69e$export$d0648489dd5697b1;
module.exports["useSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$89fe473835f648f3;
module.exports["useSmartFolderSourceContext"] = $db92b1048ab2b69e$export$81d17f5bc9dc504;

});

parcelRegister("5qRqQ", function(module, exports) {

var $4zc1o = parcelRequire("4zc1o");


var $5TdBT = parcelRequire("5TdBT");


var $8RTwe = parcelRequire("8RTwe");

const $f6a7ceb315be4336$export$13ea98513c50269a = [
    'google-drive',
    'sharepoint',
    'onedrive'
];
const $f6a7ceb315be4336$export$89232d171c71b6dd = {
    'google-drive': {
        provider: 'google-drive',
        displayName: 'Google Drive',
        fullConnectorName: 'google-drive-connector',
        connectorNames: [
            'google-drive-connector',
            'smartlinks-connector-gdrive',
            'smartlinks-connector-gdrive-rsl',
            'lite-connector-gdrive'
        ],
        Icon: (0, $4zc1o.GoogleDriveIcon)
    },
    sharepoint: {
        provider: 'sharepoint',
        displayName: 'SharePoint',
        fullConnectorName: 'sharepoint-connector',
        connectorNames: [
            'sharepoint-connector',
            'smartlinks-connector-sharepoint',
            'ai-3p-connector:sharepoint-domain'
        ],
        Icon: (0, $8RTwe.MicrosoftSharePointIcon)
    },
    onedrive: {
        provider: 'onedrive',
        displayName: 'OneDrive',
        fullConnectorName: 'onedrive-connector',
        connectorNames: [
            'smartlinks-connector-onedrive',
            'onedrive-connector'
        ],
        Icon: (0, $5TdBT.MicrosoftOneDriveIcon)
    }
};
module.exports["SMART_FOLDER_ROVO_CONNECTOR_PROVIDER_ORDER"] = $f6a7ceb315be4336$export$13ea98513c50269a;
module.exports["SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS"] = $f6a7ceb315be4336$export$89232d171c71b6dd;

});

parcelRegister("7TqMU", function(module, exports) {
const $41e745ed0b19850d$export$ea09da326533f6e = {
    OwnerDeactivated: 'owner-deactivated',
    OwnerLostAccess: 'owner-lost-access',
    FolderDeleted: 'folder-deleted',
    SyncTransientError: 'sync-transient-error',
    Empty3PFolder: 'empty-3p-folder',
    IndexingInProgress: 'indexing-in-progress'
};
const $41e745ed0b19850d$export$99646b515a29a915 = (errorType)=>{
    switch(errorType){
        case 'SYNC_CONFLUENCE_OWNER_INELIGIBLE':
        case 'SYNC_REMOTE_OWNER_DEACTIVATED':
            return $41e745ed0b19850d$export$ea09da326533f6e.OwnerDeactivated;
        case 'SYNC_REMOTE_OWNER_LOST_ACCESS':
            return $41e745ed0b19850d$export$ea09da326533f6e.OwnerLostAccess;
        case 'SYNC_REMOTE_FOLDER_DELETED':
            return $41e745ed0b19850d$export$ea09da326533f6e.FolderDeleted;
        case 'SYNC_TRANSIENT_ERROR':
            return $41e745ed0b19850d$export$ea09da326533f6e.SyncTransientError;
        case 'SYNC_EXTERNAL_FOLDER_EMPTY':
        case 'SYNC_SOURCE_FOLDER_EMPTY':
            return $41e745ed0b19850d$export$ea09da326533f6e.Empty3PFolder;
        case 'SYNC_TWG_NOT_READY':
            return $41e745ed0b19850d$export$ea09da326533f6e.IndexingInProgress;
        default:
            return null;
    }
};
module.exports["SmartFolderErrorState"] = $41e745ed0b19850d$export$ea09da326533f6e;
module.exports["getSyncErrorState"] = $41e745ed0b19850d$export$99646b515a29a915;

});

parcelRegister("3J7TU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $684d40bc929501f2$export$edb822e56299b4ef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rCmOK",
    name: "CopyPageDialog",
    loader: async ()=>(await (parcelRequire("lmtT4"))).CopyPageDialogContainer
});
module.exports["CopyPageDialog"] = $684d40bc929501f2$export$edb822e56299b4ef;

});

parcelRegister("lmtT4", function(module, exports) {

let $f8d2d609f20f78f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f8d2d609f20f78f6$var$load("6wr18"),
    $f8d2d609f20f78f6$var$load("ffEVr"),
    $f8d2d609f20f78f6$var$load("kHXvF"),
    $f8d2d609f20f78f6$var$load("Wowvf"),
    $f8d2d609f20f78f6$var$load("hhss7"),
    $f8d2d609f20f78f6$var$load("aiU5r")
]).then(()=>parcelRequire('dVBJi'));

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("7NXVF"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("7NXVF", function(module, exports) {

let $5aeb98ae4e458bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5aeb98ae4e458bfe$var$load("6wr18"),
    $5aeb98ae4e458bfe$var$load("hBTro"),
    $5aeb98ae4e458bfe$var$load("4fYzp"),
    $5aeb98ae4e458bfe$var$load("ffEVr"),
    $5aeb98ae4e458bfe$var$load("Wowvf"),
    $5aeb98ae4e458bfe$var$load("hhss7"),
    $5aeb98ae4e458bfe$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("lu0E4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $cozmU.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("b66o6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f480656426be1312$export$b62abe642254f319 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "O8EvX",
    name: "RevertEditorDialog",
    loader: async ()=>(await (parcelRequire("kwhAi"))).RevertEditorDialog
});
module.exports["RevertEditorDialog"] = $f480656426be1312$export$b62abe642254f319;

});

parcelRegister("kwhAi", function(module, exports) {

let $ef046fb0196f7b22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef046fb0196f7b22$var$load("23MlT").then(()=>parcelRequire('1yiQ2'));

});

parcelRegister("BCkug", function(module, exports) {

var $9ieTK = parcelRequire("9ieTK");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8aF6s = parcelRequire("8aF6s");


var $jv3O2 = parcelRequire("jv3O2");


var $ij4CE = parcelRequire("ij4CE");


var $bN5DJ = parcelRequire("bN5DJ");


var $3FmeR = parcelRequire("3FmeR");




const $f911f42fbae43711$export$652cb536b0ebabdb = (props)=>{
    const { contentId: contentId, spaceId: spaceId, isUnpublishedDraft: isUnpublishedDraft, analyticsSource: analyticsSource, adfOrigin: adfOrigin, onSuccessfulConversion: onSuccessfulConversion, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, saveDraft: saveDraft } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSuccess = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'convertedToLivePage',
                actionSubject: 'page',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        onSuccessfulConversion?.();
        showConvertToLivePageFlag({
            converterWasCurrentUser: true
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        onSuccessfulConversion,
        showConvertToLivePageFlag
    ]);
    const writeSubTypeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $9ieTK.default),
        fragmentArtifact: (0, $9ieTK.default),
        __callerPackage__: "live-pages-features"
    });
    return (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchToLiveEdit',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isUnpublishedDraft) showModal((0, $bN5DJ.ConvertToLivePageDialog), {
            contentId: contentId,
            onConfirm: onSuccess,
            adfOrigin: adfOrigin,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
        });
        else {
            // Trigger draft sync before converting. If we don't do this and the user recently updated their draft title then quickly converted the draft, draft sync may not have triggered and we may not identify their title conflict.
            await saveDraft?.();
            (0, $3FmeR.convertDraftToLivePage)({
                contentId: contentId,
                spaceId: spaceId,
                onSuccess: onSuccess,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                writeSubTypeFragment: writeSubTypeFragment
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        showModal,
        onSuccess,
        adfOrigin,
        retrieveEditorTitleAndContent,
        saveDraft,
        flags,
        writeSubTypeFragment
    ]);
};
module.exports["useSwitchToLivePage"] = $f911f42fbae43711$export$652cb536b0ebabdb;

});

parcelRegister("9ieTK", function(module, exports) {
/**
 * @generated SignedSource<<bf7406aa567fbba04e7cb02c4c87c8f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5dcf221c9d66892$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSwitchToLivePageSubTypeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$b5dcf221c9d66892$var$node.hash = "83901263f96d64a150282b24a00afaf6";
var $b5dcf221c9d66892$export$2e2bcd8739ae039 = $b5dcf221c9d66892$var$node;
module.exports["default"] = $b5dcf221c9d66892$export$2e2bcd8739ae039;

});

parcelRegister("bN5DJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5b509ab565dd40fa$export$13f6b1ebaf0950f0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_DPHW",
    name: "ConvertToLivePageDialog",
    loader: async ()=>(await (parcelRequire("eZHuZ"))).ConvertToLivePageDialog
});
module.exports["ConvertToLivePageDialog"] = $5b509ab565dd40fa$export$13f6b1ebaf0950f0;

});

parcelRegister("eZHuZ", function(module, exports) {

let $aea8812b84cbe978$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aea8812b84cbe978$var$load("6wr18"),
    $aea8812b84cbe978$var$load("4fYzp"),
    $aea8812b84cbe978$var$load("ffEVr"),
    $aea8812b84cbe978$var$load("RU02s")
]).then(()=>parcelRequire('9Pjdf'));

});

parcelRegister("3FmeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $fyUox = parcelRequire("fyUox");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $6s78L = parcelRequire("6s78L");


var $9Yt7A = parcelRequire("9Yt7A");


var $6LFAK = parcelRequire("6LFAK");

const $cb12ca6e6f1d2ae2$var$i18nBase = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title",
        defaultMessage: "Unable to convert draft to live page"
    },
    genericErrorFlagTitle: {
        id: "live-pages-features.converttolivepage.generic-error.title",
        defaultMessage: "An error occurred"
    }
});
const $cb12ca6e6f1d2ae2$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs",
        defaultMessage: "Unable to convert draft to live doc"
    }
});
const $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($cb12ca6e6f1d2ae2$var$i18nBase, $cb12ca6e6f1d2ae2$var$i18nLiveDocs);
const $cb12ca6e6f1d2ae2$var$preloadProperties = async (contentId, spaceId)=>{
    const tasks = [];
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceId,
        fetchPolicy: 'network-only'
    }));
    tasks.push((0, $irrTO.preloadDraftContentAppearance)(contentId, false));
    return Promise.all(tasks);
};
const $cb12ca6e6f1d2ae2$export$a4275df84ffd8722 = async ({ contentId: contentId, spaceId: spaceId = '', onSuccess: onSuccess, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, writeSubTypeFragment: writeSubTypeFragment })=>{
    try {
        const { data: mutationData } = await (0, $6s78L.mutateInterop)({
            mutation: (0, $9Yt7A.default),
            variables: {
                contentId: contentId
            },
            update: (_, { data: data })=>{
                if (data?.convertPageToLiveEditAction?.success) {
                    writeSubTypeFragment({
                        fragmentId: `Content:${contentId}`,
                        data: {
                            __typename: 'Content',
                            subType: 'live'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            },
            __callerPackage__: "live-pages-features"
        });
        const result = mutationData?.convertPageToLiveEditAction;
        if (result?.success) {
            await $cb12ca6e6f1d2ae2$var$preloadProperties(contentId, spaceId).catch(()=>{
            // Since its a preload, we don't want show an error flag
            });
            onSuccess();
            return;
        }
        result?.errors?.forEach(async (error)=>{
            (0, $6LFAK.processError)(error, contentId);
            const flagTitle = error.message === 'Title already exists' ? $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.titleConflictFlagTitle : $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle;
            const flagDescription = (0, $6LFAK.getI18nStringForError)(error.message ?? '');
            const flagDescriptionValues = {};
            if (error.message === 'Title already exists') {
                const { title: pageTitle } = await retrieveEditorTitleAndContent();
                flagDescriptionValues.pageTitle = pageTitle || '';
            }
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), flagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...flagDescription,
                    values: flagDescriptionValues
                }),
                isAutoDismiss: false
            });
        });
    } catch (error) {
        (0, $6LFAK.processError)(error, contentId);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6LFAK.i18n).unknownError),
            isAutoDismiss: false
        });
    }
};
const $cb12ca6e6f1d2ae2$export$5c2d46edf58b6daa = $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168;
module.exports["convertDraftToLivePage"] = $cb12ca6e6f1d2ae2$export$a4275df84ffd8722;

});

parcelRegister("9Yt7A", function(module, exports) {
/**
 * @generated SignedSource<<74425b153151e85569d7c520ffd47edb>>
 * @relayHash 603eb09fdbf7e41ae341d58b5067bb0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b
const $e053a44ee0757fb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConvertPageToLiveEditActionPayload",
            "kind": "LinkedField",
            "name": "convertPageToLiveEditAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "603eb09fdbf7e41ae341d58b5067bb0a",
            "id": "d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b",
            "metadata": {},
            "name": "ConvertToLivePageMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertToLivePageMutation($contentId:ID!){convertPageToLiveEditAction(input:{contentId:$contentId}){success,errors{message}}}"
        }
    };
}();
$e053a44ee0757fb3$var$node.hash = "ad615689cf4fc4a255187ebb0a30c32e";
var $e053a44ee0757fb3$export$2e2bcd8739ae039 = $e053a44ee0757fb3$var$node;
module.exports["default"] = $e053a44ee0757fb3$export$2e2bcd8739ae039;

});

parcelRegister("6LFAK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $422HI = parcelRequire("422HI");


var $jhwJP = parcelRequire("jhwJP");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");


var $7Sm4c = parcelRequire("7Sm4c");

const $49d66c83bc63de25$var$i18nBase = (0, $kSwu1.defineMessages)({
    unknownError: {
        id: "live-pages-features.converttolivepage.modal.error.unknown",
        defaultMessage: "An error occurred. Please try again."
    },
    serverException: {
        id: "live-pages-features.converttolivepage.modal.error.serverException",
        defaultMessage: "An unexpected error occurred. Please try again later."
    },
    pageNotFound: {
        id: "live-pages-features.converttolivepage.modal.error.pageNotFound",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "The page you\u2019re trying to edit doesn\u2018t exist."
    },
    contentServiceException: {
        id: "live-pages-features.converttolivepage.modal.error.contentServiceException",
        defaultMessage: "The requested content is not available."
    },
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive",
        defaultMessage: "This page has already been switched to a live page."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError",
        defaultMessage: "This page can\u2019t be switched to a live page due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions",
        defaultMessage: "You don\u2019t have the necessary permissions to switch this to a live page."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    viewScreenTitleConflict: {
        id: "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict",
        defaultMessage: "There\u2019s already content with this page\u2019s updated title in the space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs",
        defaultMessage: "This page has already been converted to a live doc."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs",
        defaultMessage: "This page can\u2019t be converted to a live doc due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs",
        defaultMessage: "You don\u2019t have the necessary permissions to convert this to a live doc."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($49d66c83bc63de25$var$i18nBase, $49d66c83bc63de25$var$i18nLiveDocs);
const $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY = {
    serverException: 'Some server exception',
    pageNotFound: 'Page not found with provided id',
    contentServiceException: 'Content service exception',
    pageAlreadyLive: 'Page subtype is already set to live',
    legacyPageConversionError: 'Legacy page cannot be converted to live edit',
    noEditPermissions: 'Page cannot be converted without edit permissions',
    draftTitleConflict: 'Title already exists'
};
const $49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE = Object.entries($49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY).reduce((acc, [key, value])=>({
        ...acc,
        [value]: key
    }), {});
const $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES = [
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.draftTitleConflict,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageAlreadyLive,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.noEditPermissions,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageNotFound
];
const $49d66c83bc63de25$export$55d2d97fdb72d6e6 = (errorMessage)=>{
    return $49d66c83bc63de25$export$a7357cdd1f0b0168[$49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE[errorMessage]] || $49d66c83bc63de25$export$a7357cdd1f0b0168.unknownError;
};
const $49d66c83bc63de25$export$ad03839ff2e809af = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    });
};
const $49d66c83bc63de25$export$83457a6c00af4df7 = (error, contentId)=>{
    let normalizedError;
    if (error instanceof Error || error instanceof (0, $422HI.ApolloErrorInterop)) normalizedError = error;
    else {
        // NOTE: Mutation errors from conversion have a null prototype, causing some below checks to throw an error because `hasOwnProperty` doesn't exist.
        //       Wrapping in a new Error retains original context and ensures the error contains `hasOwnProperty`, so we can handle the errors we're passed without issue.
        normalizedError = new Error(error?.message || 'Unknown error');
        if ('__typename' in error && error?.__typename) normalizedError.name = error?.__typename;
    }
    const isHandledConversionError = $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES.includes(normalizedError.message);
    if ((0, $1uFM6.isUnauthorizedError)(normalizedError) || (0, $6fil2.containsNetworkError)(normalizedError) || isHandledConversionError) {
        (0, $7Sm4c.markErrorAsHandled)(normalizedError);
        return {
            isHandled: true
        };
    } else {
        $49d66c83bc63de25$export$ad03839ff2e809af(normalizedError, contentId);
        return {
            isHandled: false
        };
    }
};
module.exports["i18n"] = $49d66c83bc63de25$export$a7357cdd1f0b0168;
module.exports["getI18nStringForError"] = $49d66c83bc63de25$export$55d2d97fdb72d6e6;
module.exports["processError"] = $49d66c83bc63de25$export$83457a6c00af4df7;

});

parcelRegister("9BVDK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02b364a2e855ad9d$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "N5Ue8",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("1UGoe"))).ResolvedInlineCommentsCounter
});
module.exports["ResolvedInlineCommentsCounterLoader"] = $02b364a2e855ad9d$export$20020b6b9f67a9ec;

});

parcelRegister("1UGoe", function(module, exports) {

let $164be720e616bf86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $164be720e616bf86$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});

parcelRegister("xBGBA", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $63fe8575e20fe2b8$export$8428b29fbe35d5c extends (0, $kNIYN.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $63fe8575e20fe2b8$export$8428b29fbe35d5c;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $w6R6I = parcelRequire("w6R6I");


var $3izAL = parcelRequire("3izAL");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $9aYkv.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $9aYkv.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0KLXrujOvk _1mT5xd1EEW _1pp6NdHETu _39xV02N91d _3iDTPbgBM8",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$styles = {
    base: "_0bjKvDKxmn _2Y7lL42ADO _1pp6NdIZbP _0KLXrulfZc _0xmtko1Y8M _3iDTPbQ4SZ _3TGfC9LRg7 _46hvQm1Y8M _0jFU0VN91d",
    alignCenter: "_4xdlr0DIqT"
};
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, xcss: xcss, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $w6R6I.cx)($3d1681a377877e6e$var$styles.base, isContentHeaderPinned && $3d1681a377877e6e$var$styles.alignCenter, xcss)
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("5ZyCZ"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;

});

parcelRegister("5ZyCZ", function(module, exports) {

let $45cd829fc48bdef7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45cd829fc48bdef7$var$load("6rpul").then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("8z0fF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("fkNiV"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $buxP3.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("fkNiV", function(module, exports) {

let $b29ef8132e8f15b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b29ef8132e8f15b2$var$load("dlm6q"),
    $b29ef8132e8f15b2$var$load("fb12y"),
    $b29ef8132e8f15b2$var$load("dAnEF"),
    $b29ef8132e8f15b2$var$load("48yNj"),
    $b29ef8132e8f15b2$var$load("hXYTt"),
    $b29ef8132e8f15b2$var$load("5sZTx"),
    $b29ef8132e8f15b2$var$load("deTdD"),
    $b29ef8132e8f15b2$var$load("9gCvF"),
    $b29ef8132e8f15b2$var$load("6wr18"),
    $b29ef8132e8f15b2$var$load("ffEVr"),
    $b29ef8132e8f15b2$var$load("4Ldt2"),
    $b29ef8132e8f15b2$var$load("8OeKT"),
    $b29ef8132e8f15b2$var$load("ayJxT"),
    $b29ef8132e8f15b2$var$load("6KGrg"),
    $b29ef8132e8f15b2$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("5qUgM", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $gw4Bt = parcelRequire("gw4Bt");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;

});

parcelRegister("6ug2F", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc0e6c31b10b3145$export$ad537527a445740e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GFqC1",
    name: "AgentPresenceLoader",
    loader: async ()=>(await (parcelRequire("gLfN1"))).AgentPresence
});
module.exports["AgentPresenceLoader"] = $fc0e6c31b10b3145$export$ad537527a445740e;

});

parcelRegister("gLfN1", function(module, exports) {

let $c33d48a496b7da8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c33d48a496b7da8f$var$load("cN2rp"),
    $c33d48a496b7da8f$var$load("ea3NB"),
    $c33d48a496b7da8f$var$load("48yNj"),
    $c33d48a496b7da8f$var$load("hXYTt"),
    $c33d48a496b7da8f$var$load("6wr18"),
    $c33d48a496b7da8f$var$load("3yYoj"),
    $c33d48a496b7da8f$var$load("4Ve5N"),
    $c33d48a496b7da8f$var$load("1cQg7"),
    $c33d48a496b7da8f$var$load("jqoep"),
    $c33d48a496b7da8f$var$load("VXbA1"),
    $c33d48a496b7da8f$var$load("4x9Jx"),
    $c33d48a496b7da8f$var$load("7EorR"),
    $c33d48a496b7da8f$var$load("ffEVr"),
    $c33d48a496b7da8f$var$load("hhss7"),
    $c33d48a496b7da8f$var$load("34R0T")
]).then(()=>parcelRequire('f2tcq'));

});

parcelRegister("pskhd", function(module, exports) {
const $b218ab7927acda99$export$169d32883304392c = (data)=>{
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching ?? false;
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched ?? false;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs ?? false;
    // TODO remove type checks once watch with children gate cleaned up
    const isWatchingChildren = data?.singleContent && 'currentUserIsWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserIsWatchingChildren ?? false : false;
    const hasAncestorWatchingChildren = data?.singleContent && 'currentUserHasAncestorWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserHasAncestorWatchingChildren ?? false : false;
    return {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren
    };
};
module.exports["processWatchData"] = $b218ab7927acda99$export$169d32883304392c;

});

parcelRegister("kPqqM", function(module, exports) {

var $SF9MR = parcelRequire("SF9MR");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9d7Pd = parcelRequire("9d7Pd");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $cf6nm = parcelRequire("cf6nm");


var $iCPvv = parcelRequire("iCPvv");


var $jMyy4 = parcelRequire("jMyy4");

const $3dca15cc31736255$export$f4601f3807dd9177 = ({ isDisabled: isDisabled, className: className, shortcut: shortcut, ...props })=>{
    const TooltipI18n = props.isStarred ? $3dca15cc31736255$var$i18n.Unstar : $3dca15cc31736255$var$i18n.Star;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            testId: "star-menu-item",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: className,
            isDisabled: isDisabled,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            onClick: toggleStar,
            iconAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), TooltipI18n)));
};
const $3dca15cc31736255$export$e07e4133bf676bf6 = ({ spaceKey: spaceKey })=>{
    const { data: spaceFavouriteStatusData } = (0, $jMyy4.useQueryInterop)((0, $SF9MR.default), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "action-buttons"
    });
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dca15cc31736255$export$f4601f3807dd9177, {
        isStarred: isStarred,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spacing: "none",
        spaceName: spaceName,
        shortcut: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
        shouldShowFlags: true,
        analytics: {
            attributes: {
                isContentWrapper: true,
                spaceId: // as of now, SpaceStarMenuItemWithQuery is only called from object header overflow menu
                spaceId
            },
            source: 'SpaceStarMenuItemOverflowMenu'
        }
    });
};
const $3dca15cc31736255$var$i18n = (0, $kSwu1.defineMessages)({
    Star: {
        id: "action-buttons.space.star.menu.item",
        defaultMessage: "Star space"
    },
    Unstar: {
        id: "action-buttons.space.unstar.menu.item",
        defaultMessage: "Unstar space"
    }
});
module.exports["SpaceStarMenuItem"] = $3dca15cc31736255$export$f4601f3807dd9177;
module.exports["SpaceStarMenuItemWithQuery"] = $3dca15cc31736255$export$e07e4133bf676bf6;

});

parcelRegister("SF9MR", function(module, exports) {
/**
 * @generated SignedSource<<6c76fed1cd91ee9b7df046b7fa9db63a>>
 * @relayHash 559bd430fdfdfbcc11a49c9267441232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872
const $00b16c2e2c56a4ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "559bd430fdfdfbcc11a49c9267441232",
            "id": "81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872",
            "metadata": {},
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$00b16c2e2c56a4ba$var$node.hash = "c77a49dbb962e7ad6bf61d5e4f25b221";
var $00b16c2e2c56a4ba$export$2e2bcd8739ae039 = $00b16c2e2c56a4ba$var$node;
module.exports["default"] = $00b16c2e2c56a4ba$export$2e2bcd8739ae039;

});

parcelRegister("iCPvv", function(module, exports) {

var $h4SYW = parcelRequire("h4SYW");


var $3rcpI = parcelRequire("3rcpI");


var $8DAzB = parcelRequire("8DAzB");


var $iWaZt = parcelRequire("iWaZt");


var $eUlFW = parcelRequire("eUlFW");


var $5j9jt = parcelRequire("5j9jt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $cTJK3 = parcelRequire("cTJK3");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");







const $ac59452c65a90798$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.space.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this space"
    },
    unstarErrorTitle: {
        id: "action-buttons.space.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this space"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh and try again."
    },
    starSuccessFlagTitle: {
        id: "action-buttons.space.star.success.title",
        defaultMessage: "{spaceName} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.space.unstar.success.title",
        defaultMessage: "{spaceName} unstarred"
    }
});
const $ac59452c65a90798$var$SpaceStarComponent = ({ spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, spaceName: spaceName, shouldShowFlags: shouldShowFlags })=>{
    const readCurrentSpace = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5j9jt.default),
        __callerPackage__: "action-buttons"
    });
    const readStarredSpaces = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eUlFW.default),
        __callerPackage__: "action-buttons"
    });
    const writeUpdateCurrentUserFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $iWaZt.default),
        fragmentArtifact: (0, $iWaZt.default),
        __callerPackage__: "action-buttons"
    });
    const writeStarredSpacesFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8DAzB.default),
        fragmentArtifact: (0, $8DAzB.default),
        __callerPackage__: "action-buttons"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const modifyStarCache = (0, $cozmU.useCallback)((newStarredValue)=>{
        try {
            // The (Un)FavoriteSpaceMutations do not return the updated space, so we need to manually update the cache.
            // This is necessary to update the UI immediately after the user clicks the star button.
            writeUpdateCurrentUserFragment({
                fragmentId: `Space:${spaceId}`,
                data: {
                    currentUser: {
                        isFavourited: newStarredValue,
                        __typename: 'SpaceUserMetadata'
                    },
                    __typename: 'Space'
                }
            });
            // Update the starred spaces list in the Spaces dropdown (and any other consumers of useSpacesData)
            (0, $cTJK3.updateStarredSpacesList)(spaceId, newStarredValue, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment);
        } catch  {}
    }, [
        spaceId,
        readCurrentSpace,
        readStarredSpaces,
        writeStarredSpacesFragment,
        writeUpdateCurrentUserFragment
    ]);
    const [starSpace, { error: starError }] = (0, $308Wd.useMutationInterop)((0, $3rcpI.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(false);
        },
        __callerPackage__: "action-buttons"
    });
    const [unstarSpace, { error: unstarError }] = (0, $308Wd.useMutationInterop)((0, $h4SYW.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(true);
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) onUnstar && onUnstar(e);
        else onStar && onStar(e);
        // Optimistically update the cache
        modifyStarCache(!isStarred);
        const mutation = isStarred ? unstarSpace : starSpace;
        mutation({
            variables: {
                spaceKey: spaceKey
            }
        }).then(()=>{
            if (isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
            else if (!isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.starSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
        }).catch((_)=>{});
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isStarred ? 'unstarred' : 'starred',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, [
        isStarred,
        spaceKey,
        analytics,
        starSpace,
        unstarSpace,
        modifyStarCache,
        onStar,
        onUnstar,
        createAnalyticsEvent,
        flags,
        intl,
        spaceName,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.starErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $ac59452c65a90798$export$4e2eb132a04ae560 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($ac59452c65a90798$var$SpaceStarComponent));
module.exports["SpaceStar"] = $ac59452c65a90798$export$4e2eb132a04ae560;

});

parcelRegister("h4SYW", function(module, exports) {
/**
 * @generated SignedSource<<c9db3185ab8693debf04c06c2635c98e>>
 * @relayHash 9713a87882c5e6383e438ee687952963
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495
const $1e902e1ae2e520ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "unfavouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9713a87882c5e6383e438ee687952963",
            "id": "24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495",
            "metadata": {},
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$1e902e1ae2e520ea$var$node.hash = "947f8794b11432ca2dea89537ba4c2d6";
var $1e902e1ae2e520ea$export$2e2bcd8739ae039 = $1e902e1ae2e520ea$var$node;
module.exports["default"] = $1e902e1ae2e520ea$export$2e2bcd8739ae039;

});

parcelRegister("3rcpI", function(module, exports) {
/**
 * @generated SignedSource<<fa08bda29fced98f3c45302e6ced8426>>
 * @relayHash 74b417d304c57976b899306f93428c4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647
const $55e292c0c31a2a67$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "favouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74b417d304c57976b899306f93428c4f",
            "id": "b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647",
            "metadata": {},
            "name": "SpaceStarFavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$55e292c0c31a2a67$var$node.hash = "9ac5c6d950db28ef929151bfa7f1b419";
var $55e292c0c31a2a67$export$2e2bcd8739ae039 = $55e292c0c31a2a67$var$node;
module.exports["default"] = $55e292c0c31a2a67$export$2e2bcd8739ae039;

});

parcelRegister("8DAzB", function(module, exports) {
/**
 * @generated SignedSource<<39f18a245a31c007c77ce5f5c9ee8f94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edf1f89db5626c55$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarWriteStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$edf1f89db5626c55$var$node.hash = "72f0ab1980fee3d3ebcdbd9647ddc161";
var $edf1f89db5626c55$export$2e2bcd8739ae039 = $edf1f89db5626c55$var$node;
module.exports["default"] = $edf1f89db5626c55$export$2e2bcd8739ae039;

});

parcelRegister("iWaZt", function(module, exports) {
/**
 * @generated SignedSource<<96b0d47a239a4453b03d10a247c9e028>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dd5c0573ac0253a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarActionButtonSpaceFragment",
    "selections": [
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                }
            ]
        }
    ],
    "type": "Space"
};
$3dd5c0573ac0253a$var$node.hash = "8952ed3b4f2eb093d58223c1da19fdac";
var $3dd5c0573ac0253a$export$2e2bcd8739ae039 = $3dd5c0573ac0253a$var$node;
module.exports["default"] = $3dd5c0573ac0253a$export$2e2bcd8739ae039;

});

parcelRegister("eUlFW", function(module, exports) {
/**
 * @generated SignedSource<<0b51e0ed63eacdac2772293ea5508c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae9f5e7e7a9dde99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarReadStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$ae9f5e7e7a9dde99$var$node.hash = "4a38c9f3868a7bbf44a9931e1d6903ac";
var $ae9f5e7e7a9dde99$export$2e2bcd8739ae039 = $ae9f5e7e7a9dde99$var$node;
module.exports["default"] = $ae9f5e7e7a9dde99$export$2e2bcd8739ae039;

});

parcelRegister("5j9jt", function(module, exports) {
/**
 * @generated SignedSource<<d686b0eedf9323798b549af0da2f0f71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b485608b483d3bf6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarCurrentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "alias"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ],
    "type": "Space"
};
$b485608b483d3bf6$var$node.hash = "0e7af2ea53ea33a3d76e321d036b891d";
var $b485608b483d3bf6$export$2e2bcd8739ae039 = $b485608b483d3bf6$var$node;
module.exports["default"] = $b485608b483d3bf6$export$2e2bcd8739ae039;

});

parcelRegister("cTJK3", function(module, exports) {
const $a85b49bec4fd02db$export$1c070079c48d3bdd = (spaceId, isStarred, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment)=>{
    const space = readCurrentSpace({
        id: `Space:${spaceId}`
    });
    try {
        const starredSpaces = readStarredSpaces({
            id: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`
        })?.nodes || [];
        let newStarredSpaces;
        if (isStarred) {
            newStarredSpaces = [
                ...starredSpaces,
                space
            ];
            newStarredSpaces.sort((a, b)=>!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name));
        } else newStarredSpaces = starredSpaces.filter((s)=>s?.id !== spaceId);
        writeStarredSpacesFragment({
            fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`,
            data: {
                nodes: newStarredSpaces,
                __typename: 'PaginatedSpaceList'
            }
        });
    } catch  {
    // If Apollo throws an error, the starred spaces data was not found in the cache.
    // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
    }
};
module.exports["updateStarredSpacesList"] = $a85b49bec4fd02db$export$1c070079c48d3bdd;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});


//# sourceMappingURL=NativeCollabComponent.97c1d73b.js.map
